enum ActionTypes {
	requestGroups = 'ProductGroup.requestGroups',
	receiveGroups = 'ProductGroup.receiveGroups',
	requestGroup = 'ProductGroup.requestGroup',
	receiveGroup = 'ProductGroup.receiveGroup',
	requestRecent = 'ProductGroup.requestRecent',
	receiveRecent = 'ProductGroup.receiveRecent',
	prune = 'ProductGroup.prune',
	requestCreate = 'ProductGroup.requestCreate',
	receiveCreate = 'ProductGroup.receiveCreate',
	requestUpdate = 'ProductGroup.requestUpdate',
	receiveUpdate = 'ProductGroup.receiveUpdate',
	requestRemove = 'ProductGroup.requestRemove',
	receiveRemove = 'ProductGroup.receiveRemove',
}

export default ActionTypes;
